/* eslint-disable camelcase */
class Controller {
  constructor($mdDialog, selected, hasRange, hasDate, name) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.dateType = "date";
    this.selected = selected;
    this.hasRange = hasRange;
    this.hasDate = hasDate;
    this.name = name;
  }

  close() {
    this.$mdDialog.cancel();
  }

  onChange(name) {
    if (
      name === "date" ||
      name === "travel_date" ||
      name === "createdAt" ||
      name === "created_at"
    ) {
      this.selected.start_date = null;
      this.selected.end_date = null;
    } else {
      this.selected.date = null;
      this.selected.travel_date = null;
      this.selected.createdAt = null;
      this.selected.created_at = null;
    }
  }

  confirm() {
    this.$mdDialog.hide(this.selected);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/dateFilter/dailog/dateDialog.controller.js